<template>
    <b-modal id="howTakePrintModal" :title="title" size="lg">
        <div class="details" id="printHowTake" style="max-width: 280mm">
            <div class="details_box use">
                <div class="use-item mb50">
                    <h2 class="title">한약 복용법</h2>
                    <p><span class="underline">{{application.patient_name}}</span> 님 귀하</p>
                </div>
                <div class="use-intro" style="font-size: 20px;">
                    <p>안녕하세요 <span class="underline">{{application.patient_name}}</span>님</p>
                    <p><span class="underline">{{application.clinic_nm}}</span>에서 조제된 한약 복용법에 대해서 안내해드립니다.</p>
                </div>
                <ul class="use-box">
                    <li>복용 횟수 : {{ data[1].selected === 'etc' ? data[1].etcMsg : data[1].label }}</li>
                    <li>복용 시간 : {{ data[2].selected === 'etc' ? data[2].etcMsg : data[2].label }}</li>
                    <li>복용 온도 : {{ data[3].selected === 'etc' ? data[3].etcMsg : data[3].label }}</li>
                    <li>주의해야할 음식 : {{ data[4].label }}</li>
                    <li v-if="data[4].etcMsg != ''">주의해야할 기타음식 : {{ data[4].etcMsg }}</li>
                </ul>
                <div class="use-info">
                    <h6>■ 한약 보관법</h6>
                    <p>- 직사광선이 없는 서늘한 곳에 보관하시거나 냉장 보관해주세요. (냉동실은 안됩니다)</p>
                </div>
                <div class="use-info">
                    <h6>■ 주의사항</h6>
                    <p >- 자극적인 음식이나 과식은 삼가주세요</p>
                    <p >- 과로를 피하시고 충분한 휴식과 수면은 약효 증가에 도움이 됩니다.</p>
                </div>
                <div class="use-info">
                    <h6>■ <b-icon icon="check-square"></b-icon> 표시한 사항은 참고해주세요</h6>
                    <p><b-icon icon="check-square"></b-icon> 생약이기 때문에 침전물이 생길 수 있습니다.</p>
                    <p><b-icon icon="check-square"></b-icon> 복용 중 감기 증상이 있으면 약을 중단하고 감기 치료 후 다시 복용합니다.</p>
                    <p><b-icon icon="check-square"></b-icon> 양약은 1시간 차이를 두고 드십시오.</p>
                    <p><b-icon icon="check-square"></b-icon> 약을 다 드시면 전화나 내원하여 다시 상담하시기 바랍니다.</p>
                </div>
                <div class="use-box">
                    <div class="info">
                        <p >※ 한약 복용 후 아래와 같은 명현 현상이 나타날 수도 있습니다.</p>
                        <p>
                            명현현상이란? <br>
                            체내의 독소나 노폐물들이 빠져나가면서 생기는 일시적인 반응이며, 치료 효과가 좋은 경우에 나타나는 반응입니다.
                            보통 1~2주 안에 아래와 같은 증상이 나타났다가 사라지면서 컨디션이 더욱 좋아집니다.
                        </p>
                        <div class="use-info">
                            <p><b-icon icon="check-square"></b-icon> 대변이 묽어지거나, 대변 횟수가 증가 할 수 있습니다.</p>
                            <p><b-icon icon="check-square"></b-icon> 소변량이 증가하거나, 소변횟수가 증가 할 수 있습니다.</p>
                            <!-- <p ><b-icon icon="check-square"></b-icon> 몸이 가렵거나 하는 피부 증상이 나타날 수 있습니다. (가려움증은 불편하지만 안심하세요)</p> -->
                            <p><b-icon icon="check-square"></b-icon> 복용 후 몸이 나른해지고 잠이 올 수 있습니다.</p>
                            <p><b-icon icon="check-square"></b-icon> 특히, 피부 치료의 경우에는 약을 복용 하는 초반에 증상이 악화되는 경우가 있습니다.</p>
                        </div>
                        <p>
                            위의 증상은 <span >'건강이 호전되면서 나타나는 명현반응'</span>인 경우가 많습니다. <br>
                            복용하시다가 궁금하신 사항은 한의원으로 연락주시면 감사하겠습니다.
                        </p>
                    </div>
                </div>
                <div class="use-info">
                    <h2
                        class="ac fwb"
                    >
                        {{ info }}
                    </h2>
                </div>
            </div>
        </div>
        <template #modal-footer >
            <b-button  v-if="printView != true" class="btn btn_md btn_brown" @click="print">출력</b-button>
            <b-button  class="btn btn_md btn_brown" @click="fn_close">확인</b-button>
        </template>
    </b-modal>

</template>

<script>
    import printJS from 'print-js'
    import axios from 'axios'  

    export default {
        name: 'howTakePrintModal',
        props: {
            title: {
                type: String,
                default: ''
            },
            application: {
                type: Object,
                default: () => {}
            },
            data: {
                type: Array,
                default: () => []
            },
            printView : {
                type: Boolean,
                default: false
            }
        },
        computed: {
            info () {
                let data = [this.application.howTake_clinic_name, this.application.howTake_clinic_tel, this.application.howTake_clinic_address]
                return data.join(' / ')
            }
        },
        methods: {
            print() {
                
                console.log("@@@@@ 출력");
                axios
                    .post("/api/admin/work/updatePrintStatus", this.application)
                    .then((res) => {
                        console.log("@@@@ res : %o",res);
                    })
                    .catch((err) => console.log(err));


                printJS({
                    type: 'html',
                    printable: 'printHowTake',
                    showModal: true,
                    targetStyles: ['*'],
                    onPrintDialogClose : () => {alert("@@@@@34444");}
                })
            },
            fn_close(){
                console.log("@@@@@ 1111");
                this.$bvModal.hide("howTakePrintModal"); 
            }
        },
        data () {
            return {
            }
        },        
    }
</script>

<style lang="scss" scope>
@page {
    size: A4;
}

@media print {
        * {
            print-color-adjust: exact;
            -webkit-print-color-adjust: exact;
        }
    }
</style>